/*
  Ridge & River filter profiles: the "Show all / Show fewer" toggle on long
  filter lists (snippets/rr-filter-group.liquid). Loaded by
  sections/main-collection.liquid only on collections with a filter profile.

  Warehouse re-renders the whole filter form after every filter change, so
  the expanded lists are remembered here and put back after each re-render.
*/
(function () {
  if (window.rrFiltersReady) return;
  window.rrFiltersReady = true;

  var expanded = {};

  function setExpanded(box, on) {
    box.classList.toggle('is-expanded', on);
    var button = box.querySelector('[data-rrf-more]');
    if (button) button.setAttribute('aria-expanded', on ? 'true' : 'false');

    // Let an open group grow to fit the extra values.
    var collapsible = box.closest('.collection__filter-collapsible');
    if (collapsible && collapsible.getAttribute('aria-hidden') === 'false') {
      collapsible.style.height = 'auto';
      collapsible.style.overflow = 'visible';
    }
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-rrf-more]');
    if (!button) return;
    var box = button.closest('.rrf-values');
    if (!box) return;
    var on = !box.classList.contains('is-expanded');
    expanded[box.id] = on;
    setExpanded(box, on);
  });

  function restore() {
    Object.keys(expanded).forEach(function (id) {
      var box = document.getElementById(id);
      if (box) setExpanded(box, expanded[id]);
    });
  }

  function watch() {
    var observer = new MutationObserver(restore);
    document.querySelectorAll('#desktop-filters-form, #mobile-collection-filters').forEach(function (el) {
      observer.observe(el, { childList: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watch);
  } else {
    watch();
  }
})();
